import classNames from 'classnames';
import { faqHowWeWorks } from 'data/showcase';
import { Accordion, Col, Row } from 'react-bootstrap';

const FaqHowWeWork = () => {
  return (
    <section>
      <div className="container-small">
        <Row className="flex-center">
          <Col xs={12} xl={12}>
            <h2 className="text-center mb-6 mb-sm-10">
              Frequently Asked Questions (FAQ)
            </h2>
            <Accordion
              className="border-to border-translucentp"
              defaultActiveKey="0"
            >
              {faqHowWeWorks.map((faq, index) => (
                <Accordion.Item
                  className={classNames('border-bottom border-translucent')}
                  eventKey={String(index)}
                  key={faq.id}
                >
                  <Accordion.Button className="fs-7">
                    {faq.question}
                  </Accordion.Button>
                  <Accordion.Body className="pt-0">{faq.answer}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default FaqHowWeWork;
